export const UserTypes = [
  {
    value: "Admin",
    label: "Admin"
  },
  {
    value: "Customer",
    label: "Customer"
  }
];


// WEBPACK FOOTER //
// ./src/constants/UserTypes.js